import { render, staticRenderFns } from "./IconSvgConvention.vue?vue&type=template&id=6924f510&scoped=true&"
import script from "./IconSvgConvention.vue?vue&type=script&lang=js&"
export * from "./IconSvgConvention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924f510",
  null
  
)

export default component.exports